<template>
  <vs-collapse>
    <vs-collapse-item
      v-for="item in items"
      :key="item[headerKey]"
    >
      <template #header>
        <div>
          <slot
            name="header"
            :item="item"
          >
            {{ item[headerKey] }}
          </slot>
        </div>
      </template>
      <slot
        name="content"
        :item="item"
      >
        {{ item[contentKey] }}
      </slot>
    </vs-collapse-item>
  </vs-collapse>
</template>

<script>
export default {
  name: 'CollapseList',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    headerKey: {
      type: String,
      default: 'header'
    },
    contentKey: {
      type: String,
      default: 'content'
    }
  }
}
</script>

<style scoped>

</style>
